import React from 'react';
import { Form, Radio, Button, Icon, Modal, Header } from 'semantic-ui-react';
import styled from 'styled-components';
import { ErrorMessage } from 'formik';

import PJModal from '../componentsHelpers/Modal';
import { patchDocumentUpload } from '../api/request';

const RedText = styled.p`
  color: red;
  animation: fadein 1s;

  @keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

class OnfidoDocumentUpload extends React.Component<any, any> {

  fileInputRef: any = React.createRef();

  state = {
    file: null,
    modalOpen: false,
    modalSize: 'mini',
    modalContent: null
  }

  showModal = (modalSize: any) => () => this.setState({ modalSize, modalOpen: true });

  closeModal = () => this.setState({ modalOpen: false, modalContent: null });

  next = (e: any) => {
    e.preventDefault();
    this.props.submitForm().then(() => {
      if (this.props.isValid) {
        this.onFidoDocumentUpload()
          .then(() => {
            this.props.gaEvent('event', 'IDUpload', 'Upload', 'Boots', this.props.isValid);
            this.props.manualStep('ADDITIONAL_QUESTIONS_SELECTOR', null, null, null, this.props, true, true);
          })
          .catch(() => {
            return this.props.manualStep(0);
          });
      }
    });
  };

  onFidoDocumentUpload = () => {
    const { stpDocUpload_type } = this.props.values;
    const document = this.state.file;

    return new Promise((resolve, reject) => {
      this.setState({ modalOpen: true, modalContent: this.modalContent('Uploading your Document', 'Please wait while we upload your identity document', true) });


      patchDocumentUpload(this.props.leadId, document, stpDocUpload_type, 'front')().then((response) => {
        if (response) {
          //this.setState({ modalOpen: false, modalContent: null });
          resolve(response);
        }
      }).catch(error => {
        if (error) {
          //this.setState({ modalOpen: false, modalContent: null });
          reject(error);
        }
      });

    });
  };

  modalContent = (title: string, msg?: string, spinner?: boolean) => {
    return (
      <React.Fragment>
        <Modal.Header style={{ textAlign: 'center' }}>{title}</Modal.Header>
        <Modal.Content style={{ textAlign: 'center' }}>
          {spinner ? <Icon loading name='spinner' size='massive' /> : null}
          <div className="ui divider"></div>
          {msg ? <p>{msg}</p> : null}
        </Modal.Content>
      </React.Fragment>
    );
  }

  render() {
    return (
      <React.Fragment>
        <PJModal
          size={this.state.modalSize}
          open={this.state.modalOpen}
          content={this.state.modalContent}
        />

        <Header as='h4' textAlign='left'>
          Please provide one of the following documents so that we may
          verify your identity. We accept PNGs, JPGs, and PDFs (10MB max size)
        </Header>

        <Form.Group grouped>
          <label>Document Type</label>
          <Form.Field>
            <Radio
              label="Driving Licence"
              name="stpDocUpload_type"
              value="driving_licence"
              checked={this.props.values.stpDocUpload_type === 'driving_licence'}
              onChange={() => this.props.setFieldValue('stpDocUpload_type', 'driving_licence')}
            />
          </Form.Field>
          <Form.Field>
            <Radio
              label="Passport"
              name="stpDocUpload_type"
              value="passport"
              checked={this.props.values.stpDocUpload_type === 'passport'}
              onChange={() => this.props.setFieldValue('stpDocUpload_type', 'passport')}
            />
          </Form.Field>
          <ErrorMessage
            name={'stpDocUpload_type'}
            render={msg => <RedText className="error"> {msg} </RedText>}
          />
        </Form.Group>

        <Form.Group grouped>
          <Button
            type='button'
            content="Choose File"
            labelPosition="left"
            icon="file"
            onClick={() => this.fileInputRef.current.click()}
            data-testid="doc-button-file"
          />
          <input
            name="stpDocUpload_file"
            ref={this.fileInputRef}
            type="file"
            hidden
            onChange={(e) => {
              if (e.target && e.target.files && e.target.files.length) {
                this.setState({ file: e.target.files[0] });
                this.props.setFieldValue('stpDocUpload_file', 'file added to local state');
              }
            }}
            data-testid="doc-input-file"
          />

          <ErrorMessage
            name={'stpDocUpload_file'}
            render={msg => <RedText className="error"> {msg} </RedText>}
          />
        </Form.Group>

        <Button.Group widths="2">
          <Button
            type='button'
            labelPosition="right"
            floated="right"
            color={this.props.isValid ? 'green' : 'grey'}
            icon="right chevron"
            content="Upload"
            onClick={this.next}
            data-testid="doc-button-upload"
          />
        </Button.Group>

      </React.Fragment>
    );
  }
}

export default OnfidoDocumentUpload;